import React, { Component } from "react";
import { Link } from "react-router-dom";
import { decode as base64_decode, encode as base64_encode } from "base-64";

import { observer } from "mobx-react";
import withRouter from "../withRouter";
import { StoreContext } from "../store/RootStore";
import HelpModal from "./HelpModal";
import { Tooltip,Button, Row, Col, Typography,Image,Form,Input,Checkbox} from "antd";
import Cookies from "universal-cookie";
import conf from "../config";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import {
  UserOutlined,
  LockOutlined
} from "@ant-design/icons";
import { color } from "d3";
const { Title } = Typography;
class SecureTrackLogin extends Component {
  constructor(props) {
    super(props);
    this.cookies = new Cookies();
      this.formRef = React.createRef();
  }
 
  // handleFinish = (values) => {
  //   if (this.props.onFinish) {
  //     this.props.onFinish(values);
  //   }
  // };

  render() {
    const formItemStyle = { marginBottom: "2px", marginTop: "2px" };

    return (
  
   <div className="login-screen">
      <div className="login-overlay">
        <div className="login-form-container">
          <div className="loginlogo-main">
            <Image
              src={require('../assets/images/swd-dashboard-st.png')}
              alt="SecureTrackX"
              preview={false}
              className="mainLogo"
            />
          </div>
          <div className="circle-login" >
            <div className="login-box bggreenn">
              <Button className="login-dropdown" >LOGIN</Button>
                <Form
                  name="login_form"
                  className="login-inputs"
                  onFinish={this.props.onFinish}
                  ref={this.formRef}
                  autoComplete="on" // Enable autofill
                  layout="vertical"
                >
                  <Form.Item
                    name="userEmail"
                    rules={[{ required: true, message: 'Please input your Username!' }]}
                    className="mt-2 demo-input"
                  >
                    <Input
                      prefix={<UserOutlined />}
                      placeholder="Username"
                      className="transparent-input"
                      autoComplete="username"
                      name="username"
                    />
                  </Form.Item>

                  <Form.Item
                    name="password"
                    rules={[{ required: true, message: 'Please input your Password!' }]}
                    className="mt-2"
                  >
                    <Input.Password
                      prefix={<LockOutlined />}
                      placeholder="Password"
                      className="transparent-input"
                      autoComplete="current-password"
                      name="password"
                    />
                  </Form.Item>



                  <Form.Item className="mt-4 border border-0">
                    <Button
                      type="default"
                      htmlType="submit"
                      className="login-button-2"
                      loading={this.props.loading}
                      icon={<span className="power-icon" />}
                    />
                  </Form.Item>
                </Form>



  

            </div>
          </div>
        </div>
      </div>
    </div>
    );
  }
}
//SecureTrackLogin.contextType = StoreContext;
//export default observer(withRouter(SecureTrackLogin));
export default SecureTrackLogin;
